<template>
  <div class="container">
    <HeaderComponent :callBack="_callBack"></HeaderComponent>
    <div class="row-out-con">
      <div class="row-out-left">
        <div class="row-cell" style="margin-top: 20px;"></div>
        <div class="row-cell-span">协会概况</div>
        <div class="row-out-left-con" v-if="this.infoData.xieHuiGaiKuang.length > 0">
          <div class="row-out-left-left" @click="_handleToDetail(this.infoData.xieHuiGaiKuang[0].ID)">
            <span class="inner-span">{{ this.infoData.xieHuiGaiKuang[0].post_title }}</span>
            <div class="cell-row" style="margin-bottom: 20px;">
              <span class="public-date">发布于 {{ this.infoData.xieHuiGaiKuang[0].post_date }}</span>
              <span class="public-date" style="margin-left: 20px;">浏览 {{ this.infoData.xieHuiGaiKuang[0].views_count }}</span>
            </div>
            <div class="intro">
              {{ this.infoData.xieHuiGaiKuang[0].post_content }}
            </div>
            <div class="public-date" style="margin-top: 10px;">
              查看更多 >>
            </div>
          </div>
          <div class="row-out-left-right">
            <div style="width: 100%" v-for="(item, index) in infoData.xieHuiGaiKuang" :key="item.ID">
              <div v-if="index > 0 && index <= 3" class="row-out-left-right-child" @click="_handleToDetail(item.ID)">
                <div class="title-cell">{{ item.post_title }}</div>
                <div class="cell-row">
                  <span class="public-date">发布于 {{ item.post_date }}</span>
                  <span class="public-date" style="margin-left: 20px;">浏览 {{ item.views_count }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row-cell" style="margin-top: 60px;"></div>
        <div class="row-cell-span">活动信息</div>
        <div class="row-out-left-con" v-if="this.infoData.huoDongXinXi.length > 0">
          <div class="row-out-left-left" @click="_handleToDetail(this.infoData.huoDongXinXi[0].ID)">
            <span class="inner-span">{{ this.infoData.huoDongXinXi[0].post_title }}</span>
            <div class="cell-row" style="margin-bottom: 20px;">
              <span class="public-date">发布于 {{ this.infoData.huoDongXinXi[0].post_date }}</span>
              <span class="public-date" style="margin-left: 20px;">浏览 {{ this.infoData.huoDongXinXi[0].views_count }}</span>
            </div>
            <div class="intro">
              {{ this.infoData.huoDongXinXi[0].post_content }}
            </div>
            <div class="public-date" style="margin-top: 10px;">
              查看更多 >>
            </div>
          </div>
          <div class="row-out-left-right">
            <div style="width: 100%" v-for="(item, index) in infoData.huoDongXinXi" :key="item.ID">
              <div v-if="index > 0 && index <= 3" class="row-out-left-right-child" @click="_handleToDetail(item.ID)">
                <div class="title-cell">{{ item.post_title }}</div>
                <div class="cell-row">
                  <span class="public-date">发布于 {{ item.post_date }}</span>
                  <span class="public-date" style="margin-left: 20px;">浏览 {{ item.views_count }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row-out-right">
        <span style="font-size: 18px;font-weight: bold;margin-bottom: 4px;margin-top: 10px;">新闻资讯</span>
        <div class="row-cell-right"/>
        <div style="width: 100%" v-for="(item, index) in infoData.xinWenZiXun" :key="item.ID">
          <div v-if="index <= 7" class="row-out-left-right-child" @click="_handleToDetail(item.ID)">
            <div class="title-cell">{{ item.post_title }}</div>
            <div class="cell-row">
              <span class="public-date">发布于 {{ item.post_date }}</span>
              <span class="public-date" style="margin-left: 20px;">浏览 {{ item.views_count }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 100%;display: flex;flex-direction: column;align-items: flex-start;justify-content: flex-start">
      <div class="row-cell" style="margin-top: 40px;"/>
      <div class="row-cell-span">会员中心</div>
    </div>
    <div class="cell-row" style="align-items: flex-start">
      <div v-for="(item, index) in this.infoData.huiYuanZhongXin" :key="index">
        <div class="cell-row-child" v-if="index <= 3" @click="_handleToDetail(item.ID)">
          <span style="font-size: 18px;font-weight: bold;margin-bottom: 10px">{{item.post_title}}</span>
          <div class="cell-row">
            <span class="public-date">发布于 {{ item.post_date }}</span>
            <span class="public-date" style="margin-left: 20px;">浏览 {{ item.views_count }}</span>
          </div>
          <div class="intro" style="margin-top: 10px;max-width: 280px">
            {{item.post_content}}
          </div>
        </div>
      </div>
    </div>
    <FooterComponent/>
  </div>
</template>

<script>
// @ is an alias to /src
import HeaderComponent from "@/components/HeaderComponent"
import FooterComponent from "@/components/FooterComponent"
import http from "@/util/http"

export default {
  name: 'HomeView',
  components: {
    HeaderComponent,
    FooterComponent
  },
  mounted() {
    const pageId = this.$route.query.p
    if (pageId !== undefined) {
      this._handleToDetail(pageId)
    }
    this._get()
  },
  methods: {
    _callBack(e){
      console.log(e)
    },
    _handleToDetail(e) {
      this.$router.push({
        path: '/DetailPage',
        query: {
          p: e
        }
      })
    },
    _get() {
      http.get('homePage')
      .then((res) => {
        const data = res.data
        if (data.status === 0) {
          this.infoData = data.data
        }
      })
    }
  },
  data() {
    return {
      infoData: {
        xieHuiGaiKuang: [],
        huoDongXinXi: [],
        xinWenZiXun: [],
        huiYuanZhongXin: []
      }
    }
  }
}
</script>

<style>
.row-cell-right {
  width: 100%;
  height: 5px;
  background: #333333;
}

.row-cell {
  width: 100%;
  height: 5px;
  background: #cd2122;
}

.row-out-con {
  width: 100%;
  height: 620px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.row-out-con .row-out-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  flex: 1;
}

.cell-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}

.public-date {
  font-size: 14px;
  color: #646363;
}

.intro {
  font-size: 14px;
  color: #333333;
  line-height: 26px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-weight: bold;
  text-indent: 2em;
}

.row-out-con .row-out-left .row-out-left-con {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.row-out-left-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  height: 200px;
  flex: 1;
  max-width: 380px;
  cursor: pointer;
}

.row-out-left-left .inner-span {
  font-size: 26px;
  text-overflow: ellipsis;
  font-weight: bold;
  margin-bottom: 10px;
  text-align: start;
}

.row-out-left-right {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  height: auto;
  flex: 1;
  max-width: 380px;
  cursor: pointer;
}

.row-out-left-right-child {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  height: 58px;
  border-bottom: 1px solid #f2f2f2;
  margin-bottom: 8px;
  width: 100%;
  cursor: pointer;
}

.row-out-con .row-out-right {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 380px;
  margin-left: 20px;
  height: 100%;
}

.title-cell {
  margin-bottom: 12px;
  font-size: 16px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-align: start;
  color: #444444;
  font-weight: bold;
}

.row-cell-span {
  margin-bottom: 20px;
  width: 120px;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #ffffff;
  font-weight: bold;
  background: hsla(200, 2%, 25%, 0.8) !important;
}
.cell-row-child {
  justify-content: flex-start;
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-right: 20px;
  min-width: 280px;
  cursor: pointer;
  text-align: start;
}
</style>
